<template>
  <div class="md-layout md-alignment-center spinner-overlay"
       :style="{'background-color': background, opacity: opacity}">
    <md-progress-spinner v-if="!custom" :md-diameter="diameter" :md-stroke="stroke" md-mode="indeterminate"></md-progress-spinner>
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      diameter  : {
        type   : Number,
        default: 30,
      },
      stroke    : {
        type   : Number,
        default: 3,
      },
      opacity   : {
        type   : Number,
        default: 0.7,
      },
      background: {
        type   : String,
        default: 'transparent',
      },
      custom: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="scss">
  .md-progress-spinner {
    margin: 12px;
  }

  .spinner-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
  }
</style>
